import React, { useState,useEffect } from 'react';
import { Table, TableProps} from 'antd';

interface BaseTableProps<T> extends TableProps<T>{
    handleResize?: (index: number) => (e: React.SyntheticEvent) => void
    hideSelectAll?:boolean
}
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux';


export default function SoilTable<T>({
    handleResize,
    hideSelectAll=false,
    ...rest
}: BaseTableProps<T>) {
    const dispatch = useDispatch();
    const {deleteFiled} = useSelector((state: RootState) =>state.commonData);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    useEffect(() => {
        setSelectedRowKeys([]);
    }, [deleteFiled]);
    return (
        <Table
            {...rest}
            rowSelection={{
                type: 'checkbox',
                selectedRowKeys,
                onChange: (selectedRowKey: React.Key[], selectedRows: any[]) => {
                    setSelectedRowKeys(selectedRowKey);
                    dispatch({
                        type: 'common/setDownloadFileFunction',
                        payload: {
                            downloadList: selectedRows
                        },
                    });
                },
                hideSelectAll: hideSelectAll
            }}
        />
    );
}
